import { Component, Input } from '@angular/core';
import { ChartDataset, ChartType, ChartOptions } from 'chart.js';
import { InformeEmpleados } from '../../../models/booking-reports.model';

@Component({
    selector: 'app-employees-report',
    templateUrl: './employees-report.component.html',
    styleUrls: ['./employees-report.component.scss'],
    standalone: false
})
export class EmployeesReportComponent {
  @Input() data: InformeEmpleados | null = null;

  get hasRecords(): boolean {
    return this.data != null && this.data.filas.length > 0;
  }

  getOccupancyColor(occupancy: number): string {
    if (occupancy >= 80) return 'high';
    if (occupancy >= 50) return 'medium';
    return 'low';
  }

  get occupancyChartLabels(): string[] {
    return this.data ? this.data.filas.map(r => r.nombreEmpleado) : [];
  }

  get occupancyChartData(): ChartDataset<'bar'>[] {
    return [
      {
        data: this.data ? this.data.filas.map(r => r.porcentajeOcupacion) : [],
        label: 'Ocupación (%)',
        backgroundColor: this.data
          ? this.data.filas.map(r => {
              if (r.porcentajeOcupacion >= 80) return '#28a745';
              if (r.porcentajeOcupacion >= 50) return '#e3fd64';
              return '#6c757d';
            })
          : []
      }
    ];
  }

  occupancyChartType: ChartType = 'bar';

  occupancyChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      x: {
        beginAtZero: true,
        max: 100,
        ticks: {
          callback: (value) => `${value}%`
        }
      },
      y: {
        ticks: {
          autoSkip: false
        }
      }
    }
  };

  trackByEmployee(index: number, row: any): string {
    return row.empleadoId;
  }
}